import React, { useState } from 'react';
import { WizardHeader } from '../components/tryit/WizardHeader';
import { StepIndicator } from '../components/tryit/StepIndicator';
import { PhotoUploadStep } from '../components/tryit/PhotoUploadStep';
import { BrandSelectionStep } from '../components/tryit/BrandSelectionStep';
import { VisualizationStep } from '../components/tryit/VisualizationStep';
import { motion, AnimatePresence } from 'framer-motion';
export function TryItNowPage() {
  const [step, setStep] = useState(1);
  const [data, setData] = useState({
    measurements: null,
    selection: null
  });
  const handleMeasurementsSubmit = (measurements: any) => {
    setData(prev => ({
      ...prev,
      measurements
    }));
    setStep(2);
    window.scrollTo(0, 0);
  };
  const handleSelectionSubmit = (selection: any) => {
    setData(prev => ({
      ...prev,
      selection
    }));
    setStep(3);
    window.scrollTo(0, 0);
  };
  const handleBack = () => {
    setStep(prev => Math.max(1, prev - 1));
    window.scrollTo(0, 0);
  };
  return <div className="min-h-screen bg-primary/30 pb-20" data-id="element-377">
      <WizardHeader data-id="element-378" />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-379">
        <StepIndicator currentStep={step} data-id="element-380" />

        <AnimatePresence mode="wait" data-id="element-381">
          {step === 1 && <PhotoUploadStep key="step1" onNext={handleMeasurementsSubmit} data-id="element-382" />}
          {step === 2 && <BrandSelectionStep key="step2" onNext={handleSelectionSubmit} onBack={handleBack} data-id="element-383" />}
          {step === 3 && <VisualizationStep key="step3" data-id="element-384" />}
        </AnimatePresence>
      </main>
    </div>;
}